import React from 'react';

const Certified = props => (
  <svg
    width="37"
    height="40"
    viewBox="0 0 37 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.45264 24.1444C4.87624 20.9387 7.70846 18.0506 10.8328 15.538C15.0666 14.9315 19.3588 15.0181 23.5343 15.7979C23.5927 16.8087 23.7971 17.8196 24.0891 18.7727C25.111 21.7762 26.863 26.1372 26.6294 28.7365C26.3082 32.26 21.4612 38.2094 21.4612 38.2094C21.4612 38.2094 12.8474 37.5451 9.69399 35.2058C7.56252 33.6174 5.54778 29.0541 4.11706 26.3105C3.67898 25.5307 3.12429 24.8088 2.45264 24.2023V24.1444Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.963551 23.0758L0 24.4332L1.28477 25.473C1.78116 25.935 2.1899 26.4549 2.51112 27.0614C3.38715 28.7365 4.46744 31.0758 5.69378 33.0397C6.45296 34.3683 7.44573 35.5812 8.64286 36.5632C10.0153 37.4874 11.5627 38.1516 13.1979 38.527C15.8842 39.2202 18.6289 39.6823 21.3736 39.9133L22.308 40L22.892 39.278C24.4394 37.3429 25.8411 35.2924 27.0382 33.1263C27.7682 31.7978 28.2645 30.3538 28.4689 28.8808C28.7025 26.0794 26.9213 21.4008 25.8411 18.1949C25.6075 17.3863 25.4322 16.5199 25.4031 15.6823L25.3155 14.296L23.9431 14.0362C19.5633 13.2275 15.0666 13.1119 10.6576 13.7473L10.1028 13.8051L9.69405 14.1516C6.39454 16.7798 3.47467 19.7835 0.963551 23.0758ZM2.4527 24.1444C4.8763 20.9386 7.70852 18.0506 10.8328 15.538C15.0666 14.9314 19.3589 15.0181 23.5343 15.7979C23.5927 16.8087 23.7971 17.8195 24.0891 18.7726C25.1111 21.7762 26.863 26.1372 26.6295 28.7365C26.3082 32.2599 21.4612 38.2093 21.4612 38.2093C21.4612 38.2093 12.8475 37.5451 9.69405 35.2058C7.56258 33.6173 5.54784 29.0541 4.11712 26.3105C3.67904 25.5307 3.12435 24.8086 2.4527 24.2021V24.1444Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.8628 3.78336H21.0817L21.2276 9.67499H23.038L22.8628 3.78336Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.943 10.5705L23.7386 2.85928L20.1472 2.94599L20.3224 10.6283L23.943 10.5705ZM22.8919 3.7835H21.1108L21.2567 9.67525H23.0671L22.8919 3.7835Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.4472 7.13342L30.0165 6.09375L26.3082 10.8013L27.7389 11.8411L31.4764 7.1624L31.4472 7.13342Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.885 13.0829L32.7028 7.01798L29.8122 4.90967L24.9651 11.0323L27.885 13.0829ZM31.4473 7.13343L30.0165 6.09377L26.3083 10.8013L27.739 11.841L31.4765 7.1623L31.4473 7.13343Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.2212 16.2019V14.4979L29.053 14.5845V16.2885L34.2212 16.2019Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.177 17.1841L35.1555 17.0686L35.0971 13.574L28.1187 13.6896L28.177 17.1841ZM34.2212 16.2022V14.4982L29.053 14.5849V16.2888L34.2212 16.2022Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.91992 20.852C5.2851 17.3863 8.05902 14.2093 11.1833 11.3791C15.4463 10.7148 19.7677 10.8015 24.0015 11.5813C24.06 12.6498 24.2643 13.7184 24.5563 14.7292C25.6075 17.8772 27.3595 22.1804 27.1259 24.9531C26.8047 28.7075 21.8116 34.9746 21.8116 34.9746C21.8116 34.9746 12.9936 34.2527 9.72332 31.8266C7.53342 30.1516 6.1027 26.0794 4.64265 23.1625C4.20469 22.296 3.62079 21.5451 2.91992 20.8809V20.852Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.45994 19.87L0.55481 21.1986L1.78116 22.2382C2.30675 22.7292 2.74471 23.3068 3.06593 23.9422C3.97106 25.7039 4.84709 27.8988 5.89816 29.7473C6.59903 31.0758 7.53337 32.2599 8.67208 33.2418C10.0737 34.2238 11.6504 34.9168 13.3439 35.3501C16.0886 36.0721 18.8917 36.5631 21.7241 36.823L22.7167 36.9097L23.3007 36.1588C24.9067 34.1082 26.3374 31.9422 27.5638 29.6606C28.323 28.2743 28.8194 26.7725 29.0237 25.2129C29.2865 22.2382 27.5054 17.675 26.3667 14.2671C26.1039 13.3718 25.9578 12.4766 25.8995 11.5523L25.8119 10.1661L24.4396 9.90607C20.0304 9.06857 15.4755 8.98198 11.0373 9.67505L10.4824 9.76176L10.0445 10.1372C6.83261 13.0542 3.97106 16.3754 1.54757 19.9566L1.45994 19.87ZM2.94908 20.9097C5.31426 17.444 8.08817 14.2671 11.2124 11.4368C15.4755 10.7726 19.7968 10.8591 24.0307 11.6389C24.0891 12.7076 24.2935 13.7761 24.5855 14.787C25.6367 17.935 27.3886 22.2382 27.1551 25.0107C26.8338 28.7653 21.8408 35.0324 21.8408 35.0324C21.8408 35.0324 13.0228 34.3104 9.75248 31.8844C7.56258 30.2093 6.13186 26.1371 4.67181 23.2202C4.23385 22.3538 3.64995 21.6029 2.94908 20.9385V20.9097Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.62817 21.4009C8.38012 18.7727 10.4241 16.3468 12.7599 14.2096C16.0302 13.8342 19.3297 14.0074 22.5416 14.7294C22.6 15.538 22.7168 16.3468 22.9503 17.1266C23.7095 19.5236 25.0819 22.9893 24.8776 25.0688C24.6439 27.8702 20.8189 32.5777 20.8189 32.5777C20.8189 32.5777 14.4243 32.0579 12.0884 30.2095C10.4825 28.9677 8.96414 25.2998 7.88373 23.1048C7.59172 22.4694 7.15377 21.8918 6.62817 21.4009Z"
      fill="#6930CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.03 25.4728L18.5413 26.7435L21.286 17.8194L19.5341 17.2996L17.2857 24.6642L12.3803 23.6823L12.03 25.4728Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.1767 0.924286H22.3372L22.4831 7.19138H24.3227L24.1767 0.924286Z"
      fill="#6930CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.257 8.05768L25.0527 0L21.4028 0.0865903L21.578 8.14438L25.257 8.05768ZM24.1766 0.924096H22.3372L22.4831 7.19131H24.3227L24.1766 0.924096Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.148 4.47651L30.688 3.37912L26.863 8.37552L28.323 9.47292L32.148 4.47651Z"
      fill="#6930CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.4398 10.7148L33.3744 4.27441L30.4545 2.10837L25.5199 8.5199L28.4398 10.7148ZM32.0897 4.47657L30.6297 3.37906L26.8047 8.37546L28.2646 9.47297L32.0897 4.47657Z"
      fill="#2B2D42"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35.4183 14.4692V12.6497L30.1041 12.7363V14.5558L35.4183 14.4692Z"
      fill="#6930CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.1989 15.48L36.3234 15.3644V11.7544L29.1989 11.8698V15.48ZM35.4182 14.498V12.6785L30.1041 12.7652V14.5846L35.4182 14.498Z"
      fill="#2B2D42"
    />
  </svg>
);

Certified.propTypes = {};

export default Certified;
